import { showErrorToast } from "src/components/AlertToastify/AlertToastify";
import { LoginData } from "src/mockup/LoginData";

export const loginFantasyPlatform = async (username: string, platform: string, userpassword: string, accessAuthToken, pocToken, signal?: AbortSignal): Promise<any> => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL}/fantasy_leagues/login_fantasy_platform`;

    const data: LoginData = {
      integration_name: platform,
      username: username,
      // user_email: username,
      password: userpassword,
      // year: "2025",
      pocToken: pocToken,
    };
    // console.log("LoginData", data);

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessAuthToken}`,
      },
      body: JSON.stringify(data),
      signal: signal,
      credentials: "include",
    });

    if (!response.ok) {
      throw new Error("Login failed");
    }

    const responseData = await response.json();
    // console.log("RESPONSE DATA DE GET USER DATA", responseData);
    return responseData;
  } catch (error) {
    console.error("Something went wrong while trying to log in", error);
    showErrorToast("Something went wrong while trying to log in");
    throw error;
  }
};
